<style lang="less" scoped>
  .abs-center { position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); }
  .abs-tcenter { position: absolute; top: 50%; transform: translate(0,-50%); }
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }

  .main-container {
    padding-top: 172px;
  }
  ul { margin: 0; padding: 0; list-style: none; }
  .main-container {
    min-height: 100%;
  }
  nav.nav {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 72px;
    border-bottom: 1px solid #e9edef;
    background-color: #fff;
    z-index: 4;
    h1 {
      float: left;
      width: 216px;
      height: 32px;
      background-image: url(~@/assets/icon-bi-hs.png);
      background-size: cover;
      font-size: 0; color: transparent;
      .abs-tcenter; left: 20px;
    }
  }
  .nav-menu {
    float: right;
    padding: 16px 40px 0 0;
    font-size: 14px;
    .member {
      float: left;
      position: relative;
      line-height: 40px;
      margin-right: 10px;
      top: -16px;
      &::after {
        content: '';
        .abs-tcenter;
        right: 2px;
        width: 9px;
        height: 5px;
        background-image: url(~@/assets/icon-mypage-arr.png);
        background-size: cover;
      }
      span {
        padding: 0 21px;
        line-height: 70px;
      }
      ul {
        &::before {
          content: '';
          .abs-lcenter;
          top: -12px;
          width: 17px;
          height: 12px;
          background-image: url(~@/assets/icon-sub-arr.png);
          background-size: cover;
        }
        display: none;
        position: absolute;
        top: 62px;
        z-index: 2;
        width: 91px;
        padding: 10px 0;
        border: 1px solid #e0e4e6;
        border-radius: 5px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0 rgba(0, 0, 0, 0.08);
        li {
          a {
            display: block;
            text-indent: 14px;
            line-height: 33px;
            &:hover {
              background-color: #f0f0f2;
            }
          }
        }
      }

      &:hover {
        ul {
          display: block;
        }
      }
    }
    a.btn {
      float: left;
      position: relative;
      line-height: 38px;
      border: 1px solid #dde1e3;
      border-radius: 20px;
      font-weight: bold;
      margin-left: 10px;
      box-sizing: border-box;
      &.biz-money {
        cursor: pointer;
        color: #ff6c00;
        min-width: 200px;
        padding-right: 40px;
        &::before {
          content: '비즈머니 :';
          color: #303030;
          padding: 0 3px 0 17px;
        }
        &::after {
          content: '';
          .abs-tcenter;
          right: 9px;
          width: 22px;
          height: 22px;
          background-image: url(~@/assets/icon-biz.png);
          background-size: cover;
        }
      }
      &.ad-pdf {
        padding: 0 45px 0 17px;
        &::after {
          content: '';
          .abs-tcenter;
          right: 9px;
          width: 22px;
          height: 22px;
          background-image: url(~@/assets/icon-proposal.png);
          background-size: cover;
        }
      }
    }
  }
  nav.sub-nav {
    position: fixed;
    top: 72px;
    left: 0;
    width: 100%;
    z-index: 3;
    height: 100px;
    border-bottom: 1px solid #e9edef;
    background-color: #fff;

    ol {
      .abs-tcenter;
      word-spacing: -3px;
      padding: 0 20px;
      >li {
        float: left;
        font-size: 18px;
        >a {
          display: block;
          line-height: 70px;
          padding: 0 20px;
          &.active {
            color: #ff6c00;
          }
        }

        &.sub {
          position: relative;
          padding: 0 20px 0 0;
          >a {
            &::after {
              content: '';
              .abs-tcenter;
              right: 20px;
              width: 11px;
              height: 6px;
              margin-top: 1px;
              background-image: url(~@/assets/icon-gnb-arr.png);
              background-size: cover;
            }
            &.active {
              &::after {
                background-image: url(~@/assets/icon-gnb-arr-active.png);
              }
            }
          }
        }

        &:hover {
          // >a {
          //   color: #ff6c00;
          // }
          ul {
            display: block;
          }
        }
      }
    }
    ul {
      &::before {
        content: '';
        .abs-lcenter;
        top: -12px;
        width: 17px;
        height: 12px;
        margin-left: -8px;
        background-image: url(~@/assets/icon-sub-arr.png);
        background-size: cover;
      }
      display: none;
      .abs-lcenter;
      top: 65px;
      width: 147px;
      background-color: #fff;
      border: 1px solid #e0e4e6;
      border-radius: 5px;
      font-size: 17px;
      padding: 15px 0;
      box-shadow: 0px 2px 5px 0 rgba(0, 0, 0, 0.08);
      li {
        a {
          display: block;
          line-height: 45px;
          text-indent: 17px;
          &:hover, &.active {
            background-color: #f0f0f2;
          }
        }
      }
    }
  }
</style>

<template lang="pug">
  .main-container
    nav.nav
      router-link(to="/")
        h1 Marketing Center
      .nav-menu
        .member
          span {{ me.sname }}
          ul
            li
              router-link(to="/user/verify") 정보수정
            li
              router-link(to="/user/activity") 이력조회
            li
              a(@click="logout") 로그아웃
        a.btn.biz-money(@click="visible = true")
          span {{ bizMoney | displayBizMoney }}
        a.btn.ad-pdf(download="광고 제안서", href="/file/sta1_ad_proposal_20193Q.pdf") 광고 제안서
    nav.sub-nav
      ol
        li
          router-link(to="/main") 성과요약
        li.sub
          router-link(to="/shop") SHOP 관리
          ul
            li
              router-link(to="/shop/best") BEST 상품관리
            li
              router-link(to="/shop/products") 전체 상품관리
        li.sub
          router-link(to="/management") 광고 관리
          ul
            li
              router-link(to='/management/bid') 광고 입찰
            li
              router-link(to='/management/click') 클릭 내역
            li
              router-link(to='/management/order') 구매 내역
            li
              router-link(to='/management/join') 가입 내역
        li.sub
          router-link(to="/bizmoney") 비즈머니 내역
          ul
            li
              router-link(to='/bizmoney/paylist') 결제 내역
            li
              router-link(to='/bizmoney/bonus') 보너스 내역
    router-view
    bizmoney-dialog(:visible="visible", :bizMoney="bizMoney", @close="closeDialog")
</template>

<script>
import { mapState } from 'vuex';
import BizmoneyDialog from '@/components/BizmoneyDialog.vue';

export default {
  components: {
    BizmoneyDialog,
  },
  metaInfo: {
    script: [
      { charset: 'euc-kr', src: 'https://tx.allatpay.com/common/NonAllatPayRE.js' },
    ],
  },
  methods: {
    async closeDialog(type) {
      console.log('type', type);
      if (type !== undefined || type === 'Y') {
        const bizMoney = await this.$http.get('/api/mkc/v1/store-biz-money-now');
        this.bizMoney = (bizMoney.data.data.bizMoney + bizMoney.data.data.bizPoint);
        if (type === 'Y') {
          this.$router.push('/bizmoney');
        }
      }

      this.visible = false;
    },
    testClassName({ row, rowIndex }) {
      console.log(row, rowIndex);
      return 'test-siche';
    },
    logout() {
      localStorage.removeItem('token');
      window.location.href = '/login';
    },
  },
  async mounted() {
    const bizMoney = await this.$http.get('/api/mkc/v1/store-biz-money-now');
    this.bizMoney = (bizMoney.data.data.bizMoney + bizMoney.data.data.bizPoint);
  },
  filters: {
    displayBizMoney(value) {
      return value.toLocaleString();
    },
  },
  computed: {
    ...mapState({
      me: state => state.me,
    }),
  },
  data() {
    return {
      bizMoney: 0,
      shopName: null,
      visible: false,
      // 테이블 데이터
      tableData: [
        {
          price: '₩ 300,000',
          bonus: '₩ 0',
        },
        {
          price: '₩ 500,000',
          bonus: '₩ 10,000',
        },
        {
          price: '₩ 1,000,000',
          bonus: '₩ 50,000',
        },
        {
          price: '₩ 3,000,000',
          bonus: '₩ 200,000',
        },
        {
          price: '₩ 5,000,000',
          bonus: '₩ 400,000',
        },
        {
          price: '₩ 10,000,000',
          bonus: '₩ 1,000,000',
        },
      ],
      price: '',
    };
  },
};
</script>
